import Icon from 'design-system/Image/Image';
import { useMemo } from 'react';
import { ReactComponent as SnackerrorIcon } from 'resources/svg/icons/Snackerror.svg';
import { ReactComponent as SnackinfoIcon } from 'resources/svg/icons/Snackinfo.svg';
import { ReactComponent as SnacksuccessIcon } from 'resources/svg/icons/Snacksuccess.svg';
import { ReactComponent as SnackwarningIcon } from 'resources/svg/icons/Snackwarning.svg';
import { NotificationType } from 'types/common/notification';

type SnackIconProps = { type: NotificationType };

const SnackIcon = ({ type }: SnackIconProps) => {
  const IconComponent = useMemo(() => {
    switch (type) {
      case 'error':
        return SnackerrorIcon;
      case 'success':
        return SnacksuccessIcon;
      case 'warning':
        return SnackwarningIcon;
      case 'info':
        return SnackinfoIcon;
      default:
        return null;
    }
  }, [type]);

  return <Icon name={`Snack${type}`}>{IconComponent && <IconComponent />}</Icon>;
};

export default SnackIcon;
